import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import ContactPage from './pages/Contact';
import ChoisirSiteParis from './pages/guides/ChoisirSiteParis';
import ComprendreCotes from './pages/guides/ComprendreCotes';
import TypesParis from './pages/guides/TypesParis';
import GererBankroll from './pages/guides/GererBankroll';
import MethodesPaiement from './pages/guides/MethodesPaiement';
import SecuriteLicences from './pages/guides/SecuriteLicences';
import BonusPromotions from './pages/guides/BonusPromotions';
import ParisDirect from './pages/guides/ParisDirect';
import JeuResponsable from './pages/guides/JeuResponsable';
import News from './pages/News';
import TendancesParisSportifs2025 from './pages/news/TendancesParisSportifs2025';
import NouveauxBonusNovembre from './pages/news/NouveauxBonusNovembre';
import GererBankrollProfessionnel from './pages/news/GererBankrollProfessionnel';
import ReglementationsAnj2025 from './pages/news/ReglementationsAnj2025';
import MethodesPaiementRapides from './pages/news/MethodesPaiementRapides';
import AnalyseCotesCompetitives from './pages/news/AnalyseCotesCompetitives';
import LiveBettingStrategies from './pages/news/LiveBettingStrategies';
import ProtectionDonneesParieurs from './pages/news/ProtectionDonneesParieurs';
import ErreursParieursDebutants from './pages/news/ErreursParieursDebutants';
import Reviews from './pages/Reviews';
import NetBet from './pages/reviews/NetBet';
import UniBet from './pages/reviews/UniBet';
import Vbet from './pages/reviews/Vbet';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
          <Route path="/reviews/netbet" element={<NetBet />} />
          <Route path="/reviews/unibet" element={<UniBet />} />
          <Route path="/reviews/vbet" element={<Vbet />} />
          <Route path="/news/tendances-paris-sportifs-2025" element={<TendancesParisSportifs2025 />} />
          <Route path="/news/nouveaux-bonus-novembre" element={<NouveauxBonusNovembre />} />
          <Route path="/news/gerer-bankroll-professionnel" element={<GererBankrollProfessionnel />} />
          <Route path="/news/reglementations-anj-2025" element={<ReglementationsAnj2025 />} />
          <Route path="/news/methodes-paiement-rapides" element={<MethodesPaiementRapides />} />
          <Route path="/news/analyse-cotes-competitives" element={<AnalyseCotesCompetitives />} />
          <Route path="/news/live-betting-strategies" element={<LiveBettingStrategies />} />
          <Route path="/news/protection-donnees-parieurs" element={<ProtectionDonneesParieurs />} />
          <Route path="/news/erreurs-parieurs-debutants" element={<ErreursParieursDebutants />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/choisir-site-paris" element={<ChoisirSiteParis />} />
          <Route path="/guides/comprendre-cotes" element={<ComprendreCotes />} />
          <Route path="/guides/types-paris" element={<TypesParis />} />
          <Route path="/guides/gerer-bankroll" element={<GererBankroll />} />
          <Route path="/guides/methodes-paiement" element={<MethodesPaiement />} />
          <Route path="/guides/securite-licences" element={<SecuriteLicences />} />
          <Route path="/guides/bonus-promotions" element={<BonusPromotions />} />
          <Route path="/guides/paris-direct" element={<ParisDirect />} />
          <Route path="/guides/jeu-responsable" element={<JeuResponsable />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Router>
      <AgeVerification />
      <CookieConsent />
    </>
  );
}

export default App;
